import { render } from "./TestPrint.vue?vue&type=template&id=5aca612d&scoped=true"
import script from "./TestPrint.vue?vue&type=script&lang=js"
export * from "./TestPrint.vue?vue&type=script&lang=js"

import "./TestPrint.vue?vue&type=style&index=0&id=5aca612d&scoped=true&lang=css"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aca612d"]])

export default __exports__